import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import * as actionTypes from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const MODULE_REGISTRATION = actionTypes.GLOBAL_STATE

const moduleRegistrationSlice = createSlice({
  name: MODULE_REGISTRATION,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.moduleRegistration.pending, state => {
        state[actionTypes.MODULE_REGISTRATION].loading = true
      })
      .addCase(actionCreators.moduleRegistration.rejected, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION].loading = false
        state[actionTypes.MODULE_REGISTRATION].error = action.payload as AxiosError
      })
      .addCase(actionCreators.moduleRegistration.fulfilled, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION].loading = false
        state[actionTypes.MODULE_REGISTRATION].error = null
        state[actionTypes.MODULE_REGISTRATION].data = action.payload
      })

    builder
      .addCase(actionCreators.moduleRegistrationAll.pending, state => {
        state[actionTypes.MODULE_REGISTRATION_ALL].loading = true
      })
      .addCase(actionCreators.moduleRegistrationAll.rejected, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION_ALL].loading = false
        state[actionTypes.MODULE_REGISTRATION_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.moduleRegistrationAll.fulfilled, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION_ALL].loading = false
        state[actionTypes.MODULE_REGISTRATION_ALL].error = null
        state[actionTypes.MODULE_REGISTRATION_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.moduleRegistrationCreate.pending, state => {
        state[actionTypes.MODULE_REGISTRATION_CREATE].loading = true
      })
      .addCase(actionCreators.moduleRegistrationCreate.rejected, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION_CREATE].loading = false
        state[actionTypes.MODULE_REGISTRATION_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.moduleRegistrationCreate.fulfilled, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION_CREATE].loading = false
        state[actionTypes.MODULE_REGISTRATION_CREATE].error = null
        state[actionTypes.MODULE_REGISTRATION_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.moduleRegistrationDelete.pending, state => {
        state[actionTypes.MODULE_REGISTRATION_DELETE].loading = true
      })
      .addCase(actionCreators.moduleRegistrationDelete.rejected, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION_DELETE].loading = false
        state[actionTypes.MODULE_REGISTRATION_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.moduleRegistrationDelete.fulfilled, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION_DELETE].loading = false
        state[actionTypes.MODULE_REGISTRATION_DELETE].error = null
        state[actionTypes.MODULE_REGISTRATION_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.moduleRegistrationList.pending, state => {
        state[actionTypes.MODULE_REGISTRATION_LIST].loading = true
      })
      .addCase(actionCreators.moduleRegistrationList.rejected, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION_LIST].loading = false
        state[actionTypes.MODULE_REGISTRATION_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.moduleRegistrationList.fulfilled, (state, action) => {
        state[actionTypes.MODULE_REGISTRATION_LIST].loading = false
        state[actionTypes.MODULE_REGISTRATION_LIST].error = null
        state[actionTypes.MODULE_REGISTRATION_LIST].data = action.payload
      })

    builder.addCase(actionCreators.moduleRegistrationClear, state => {
      state[actionTypes.MODULE_REGISTRATION] = defaultState()
    })

    builder.addCase(actionCreators.moduleRegistrationAllClear, state => {
      state[actionTypes.MODULE_REGISTRATION_ALL] = defaultState()
    })

    builder.addCase(actionCreators.moduleRegistrationListClear, state => {
      state[actionTypes.MODULE_REGISTRATION_LIST] = defaultState()
    })
  },
})

export const { reducer: moduleRegistrationReducer } = moduleRegistrationSlice
